// /pages/HR/utils/mockData.js

/**
 * Mock Data for HR Dashboard
 * Development data matching the dashboard structure
 */

export const mockHRData = {
  // Main KPIs
  kpis: {
    totalTickets: 846,
    completionRate: 100.0,
    avgDaysOpen: 12.0,
    trends: {
      totalTickets: { value: 846, change: 12.5, direction: "up" },
      completionRate: { value: 100, change: 5.2, direction: "up" },
      avgDaysOpen: { value: 12.0, change: -2.1, direction: "down" },
    },
  },

  // Location metrics - format matches API response
  locationMetrics: [
    { market: "FL", open: 0, completed: 46 },
    { market: "MA", open: 0, completed: 263 },
    { market: "ME", open: 0, completed: 125 },
    { market: "NH", open: 0, completed: 267 },
    { market: "NY", open: 0, completed: 38 },
    { market: "RI", open: 0, completed: 70 },
  ],

  // Category breakdown for bar chart
  categoryBreakdown: [
    { category: "HR - Employee Mo...", count: 5, order: 1 },
    { category: "Compl./Incident", count: 8, order: 2 },
    { category: "Benefits Request", count: 9, order: 3 },
    { category: "People Plan", count: 10, order: 4 },
    { category: "Employee Incident", count: 14, order: 5 },
    { category: "Minor Documentation", count: 14, order: 6 },
    { category: "HR Complaint/Concern", count: 19, order: 7 },
    { category: "Employee Information Change Request", count: 30, order: 8 },
    { category: "TA", count: 35, order: 9 },
    { category: "Writing Assessment", count: 103, order: 10 },
    { category: "Employee Leave", count: 123, order: 11 },
    { category: "Employment Verification", count: 223, order: 12 },
    { category: "Payroll Request", count: 253, order: 13 },
  ],

  // Weekly data for combo chart
  weeklyData: [
    { week: "W14", weekStart: "2024-03-31", created: 76, avgDaysOpen: 15.7 },
    { week: "W15", weekStart: "2024-04-07", created: 79, avgDaysOpen: 22.0 },
    { week: "W16", weekStart: "2024-04-14", created: 53, avgDaysOpen: 15.14 },
    { week: "W17", weekStart: "2024-04-21", created: 63, avgDaysOpen: 26.88 },
    { week: "W18", weekStart: "2024-04-28", created: 65, avgDaysOpen: 15.14 },
    { week: "W19", weekStart: "2024-05-05", created: 71, avgDaysOpen: 11.21 },
    { week: "W20", weekStart: "2024-05-12", created: 88, avgDaysOpen: 13.74 },
    { week: "W21", weekStart: "2024-05-19", created: 65, avgDaysOpen: 13.44 },
    { week: "W22", weekStart: "2024-05-26", created: 36, avgDaysOpen: 7.56 },
    { week: "W23", weekStart: "2024-06-02", created: 54, avgDaysOpen: 7.25 },
    { week: "W24", weekStart: "2024-06-09", created: 50, avgDaysOpen: 8.88 },
    { week: "W25", weekStart: "2024-06-16", created: 95, avgDaysOpen: 6.95 },
    { week: "W26", weekStart: "2024-06-23", created: 51, avgDaysOpen: 3.22 },
    { week: "W27", weekStart: "2024-06-30", created: 14, avgDaysOpen: 14.0 },
  ],

  // Generalist performance data - UPDATED WITH NEW NAMES
  generalistData: [
    { name: "Corey Rogers", completed: 35, percentage: 5.1 },
    { name: "Dustin Loiselle", completed: 36, percentage: 5.3 },
    { name: "Shelly Sweeney", completed: 73, percentage: 10.7 },
    { name: "Mariela Ameglio", completed: 116, percentage: 17.1 },
    { name: "Mike Kleiner", completed: 99, percentage: 14.6 },
    { name: "Zachary Newquist", completed: 321, percentage: 47.2 },
  ],

  // Market distribution for pie chart
  marketDistribution: [
    { market: "NH", count: 267, percentage: 31.56, color: "#3B82F6" },
    { market: "MA", count: 263, percentage: 31.09, color: "#8B5CF6" },
    { market: "ME", count: 125, percentage: 14.78, color: "#F59E0B" },
    { market: "RI", count: 70, percentage: 8.27, color: "#10B981" },
    { market: "FL", count: 49, percentage: 5.79, color: "#EF4444" },
    { market: "NY", count: 38, percentage: 4.49, color: "#14B8A6" },
    { market: "XX", count: 34, percentage: 4.02, color: "#F46B02" },
  ],

  // Sample request tickets for HR Requests page
  sampleTickets: [
    {
      id: "HR-2024-001",
      title: "Annual Leave Request - John Doe",
      category: "employee_leave",
      status: "pending",
      priority: 2,
      location: "MA",
      createdDate: "2024-06-20",
      dueDate: "2024-06-25",
      assignee: "Diana Carrero",
      requester: "John Doe",
      description: "Annual leave request for summer vacation",
    },
    {
      id: "HR-2024-002",
      title: "Payroll Adjustment - Jane Smith",
      category: "payroll",
      status: "in_progress",
      priority: 1,
      location: "NY",
      createdDate: "2024-06-21",
      dueDate: "2024-06-22",
      assignee: "Zachary Newquist",
      requester: "Jane Smith",
      description: "Overtime hours not reflected in last paycheck",
    },
    {
      id: "HR-2024-003",
      title: "Benefits Enrollment - New Hire",
      category: "benefits",
      status: "completed",
      priority: 2,
      location: "FL",
      createdDate: "2024-06-15",
      dueDate: "2024-06-20",
      completedDate: "2024-06-19",
      assignee: "Mariela Ameglio",
      requester: "Mike Johnson",
      description: "New employee benefits enrollment",
    },
    // Add more sample tickets as needed
  ],

  // Last updated timestamp
  lastUpdated: new Date().toISOString(),

  // Summary statistics
  summary: {
    totalRequests: 846,
    completedThisWeek: 51,
    pendingApproval: 23,
    overdueRequests: 0,
    avgResolutionTime: 12.0,
    satisfactionScore: 4.8,
  },

  // Filters state
  defaultFilters: {
    dateRange: {
      startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), // Last 30 days
      endDate: new Date(),
      preset: "last30days",
    },
    locations: [],
    categories: [],
    status: "all",
  },
};

// Generate additional mock data helpers
export const generateMockTickets = (count = 100) => {
  const tickets = [];
  const categories = mockHRData.categoryBreakdown.map((c) => c.category);
  const locations = mockHRData.locationMetrics.map((l) => l.location);
  const assignees = mockHRData.generalistData.map((g) => g.name);
  const statuses = ["pending", "in_progress", "completed", "overdue"];

  for (let i = 0; i < count; i++) {
    const createdDate = new Date(
      Date.now() - Math.random() * 90 * 24 * 60 * 60 * 1000
    );
    const dueDate = new Date(
      createdDate.getTime() + Math.random() * 14 * 24 * 60 * 60 * 1000
    );

    tickets.push({
      id: `HR-2024-${String(i + 1).padStart(3, "0")}`,
      title: `Request ${i + 1}`,
      category: categories[Math.floor(Math.random() * categories.length)],
      status: statuses[Math.floor(Math.random() * statuses.length)],
      priority: Math.floor(Math.random() * 3) + 1,
      location: locations[Math.floor(Math.random() * locations.length)],
      createdDate: createdDate.toISOString().split("T")[0],
      dueDate: dueDate.toISOString().split("T")[0],
      assignee: assignees[Math.floor(Math.random() * assignees.length)],
      requester: `Employee ${i + 1}`,
      description: `Description for request ${i + 1}`,
    });
  }

  return tickets;
};

// Export default for easy import
export default mockHRData;
